import {
    initEmptyData,
    inputActions,
} from '../store/actions/modelsActions/control'
import { configsActions } from '../store/slices/configsSlice'
import {
    initRuleEmptyData,
    modifyRuleCardConfig,
} from '../store/actions/ruleCardActions'
import { ruleCardActions } from '../store/slices/ruleCardSlice'

interface IInputDataDispatcher {
    isEmpty: boolean
    name: string
    path: string[]
    dataSchema: any
    inputState: any
    validationCheck: any
    errorKey: string
    isUndefined: boolean
    data: any
    guid?: string
    checkPath?: string[]
    type?: string
    isRuleCard?: boolean
}

export function inputDataDispatcher(
    data: IInputDataDispatcher,
    dispatch: Function
) {
    const {
        isEmpty,
        name,
        path,
        dataSchema,
        data: dataPrev,
        inputState,
        validationCheck,
        guid,
        errorKey,
        isUndefined,
        checkPath,
        type,
        isRuleCard,
    } = data
    const tabName: string = path[2]
    const value = inputState?.[name]
    const isValid = validationCheck?.isValidSync(value)
    const hasChanged = dataPrev?.[name] !== value

    if (isRuleCard) {
        if (path.length <= 1) {
            return dispatch(
                ruleCardActions.setRuleConfigValid({ errorKeyName: errorKey })
            )
        }

        if (isEmpty) {
            dispatch(initRuleEmptyData({ name, path, schema: dataSchema }))
        }

        if (hasChanged) {
            dispatch(modifyRuleCardConfig({ path, data: inputState }))
        }

        if (!isValid) {
            dispatch(
                ruleCardActions.setRuleConfigInvalid({ errorKeyName: errorKey })
            )
        }

        if (isValid && !isUndefined) {
            dispatch(
                ruleCardActions.setRuleConfigValid({ errorKeyName: errorKey })
            )
        }
    } else {
        if (path.length <= 2) {
            return dispatch(
                configsActions.setConfigValid({
                    guid: checkPath?.[0] || '',
                    tabName: checkPath?.[2] || '',
                    errorKeyName: (checkPath || []).join(''),
                })
            )
        }

        if (isEmpty) {
            dispatch(initEmptyData({ name, path, schema: dataSchema }))
        }

        if (hasChanged) {
            dispatch(
                inputActions.modify(inputState, path, inputState, name, type)
            )
        }

        if (!isValid) {
            dispatch(
                configsActions.setConfigInvalid({
                    guid: guid!,
                    tabName,
                    errorKeyName: errorKey,
                })
            )
        }

        if (isValid && !isUndefined) {
            dispatch(
                configsActions.setConfigValid({
                    guid: guid!,
                    tabName,
                    errorKeyName: errorKey,
                })
            )
        }
    }
}
